










































































































import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapActions, mapState, mapGetters } from "vuex";
import * as a from "@/store/modules/ApplicationModule/actions";

// Model
import { DEVICE_TREE_CONSTANTS as K } from "@/utility/Constants";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { SearchFilter } from "@/model/communication/device/SearchDevicesReqData";
import { TagValues } from "@/model/data/Tag";
import { SearchDevicesCommand } from "@/model/communication/device/SearchDevicesCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

const MAX_ITEMS_TO_OPEN_ALL = 200;

export default Vue.extend({
    data() {
        return {
            K,
            DeviceTreeNodeTypeEnum,
            loading: false,
            searchFilter: {},
            selectedFolder: null,
            selectedBranch: null,
            selectedTagKey: null,
            selectedTagValue: null,
            localSelection: [],
            searchResults: [],
            openAll: false,
        };
    },
    props: {
        folderIdsWhereSearchIn: Array,
        value: Array,
        preselectedFolderId: { required: false },
    },
    computed: {
        ...mapState({
            availableBranches: (state: RootState) => state.application.availableBranches,
            availableTags: (state: RootState): TagValues[] => state.application.availableTags,
        }),
        ...mapGetters(["folderIdsAndNames"]),

        comboboxFolderItems() {
            return this.folderIdsAndNames.map((item) => ({ text: item.name, value: item.id }));
        },

        comboboxBranchItems() {
            return this.availableBranches.map((item) => ({ text: item.name, value: item.id }));
        },

        comboboxTagKeyItems() {
            return this.availableTags ? this.availableTags.map((c) => c.tagName).sort() : [];
        },

        showTagValuesCombobox() {
            return this.selectedTagKey != null && this.availableTags.map((c) => c.tagName).indexOf(this.selectedTagKey) > -1;
        },

        comboboxTagValueItems() {
            return this.showTagValuesCombobox ? this.availableTags.filter((c) => c.tagName == this.selectedTagKey)[0].availableValues.sort((a, b) => a - b) : [];
        },

        canSubmitSearch() {
            if (this.searchFilter.installationName && this.searchFilter.installationName.length > 0) return true;
            if (this.searchFilter.machinesSerialNumber && this.searchFilter.machinesSerialNumber.length > 0) return true;
            if (this.searchFilter.folderId != null) return true;
            if (this.searchFilter.branchId != null) return true;
            if (this.searchFilter.tag)
                if (this.searchFilter.tag.tagName && this.searchFilter.tag.tagName.length > 0)
                    if (this.searchFilter.tag.availableValues && this.searchFilter.tag.availableValues.length > 0) return true;
            return false;
        },
    },
    watch: {
        selectedFolder(newValue) {
            this.searchFilter.folderId = newValue ? newValue.value : null;
        },

        selectedBranch(newValue) {
            this.searchFilter.branchId = newValue ? newValue.value : null;
        },

        selectedTagKey(newValue) {
            this.searchFilter.tag = new TagValues();
            this.searchFilter.tag.tagName = newValue;
            this.selectedTagValue = null;
            this.searchFilter["tag.tagName"] = null;
            this.searchFilter["tag.availableValues"] = [];
        },

        selectedTagValue(newValue) {
            this.searchFilter.tag.availableValues = [];
            if (newValue) this.searchFilter.tag.availableValues.push(newValue);
            else this.searchFilter["tag.availableValues"] = [];
        },

        localSelection(newLocalSelection) {
            // aggiungo i nodi che mancano
            var tempSelection = [];
            Object.assign(tempSelection, this.value);
            newLocalSelection.forEach((item) => {
                if (tempSelection.map((t) => t.id).indexOf(item.id) < 0) tempSelection.push(item);
            });

            // rimuovo i nodi mancanti
            if (this.value)
                this.value.forEach((item) => {
                    if (this.searchResultsFlat(this.searchResults).indexOf(item.id) > -1) {
                        if (newLocalSelection.map((t) => t.id).indexOf(item.id) < 0) {
                            var index = tempSelection.map((t) => t.id).indexOf(item.id);
                            if (index > -1) tempSelection.splice(index, 1);
                        }
                    }
                });
            this.$emit("input", tempSelection);
        },
    },
    methods: {
        ...mapActions([a.GET_AVAILABLE_TAGS, a.GET_AVAILABLE_BRANCHES]),

        async close() {
            this.searchResults = null;
            this.$emit("close", this.value);
        },

        async onSearchDeviceClick() {
            if (this.canSubmitSearch) {
                try {
                    this.loading = true;

                    var res = await new SearchDevicesCommand(this.searchFilter as SearchFilter).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.searchResults = [];
                        this.openAll = this.searchResultsFlat(res.deviceTree).length < MAX_ITEMS_TO_OPEN_ALL;
                        setTimeout(() => {
                            this.searchResults = res.deviceTree;
                        }, 150);
                        Object.assign(this.localSelection, this.value);
                        this.loading = false;
                    }
                } catch (error) {
                    console.error("Error executing SearchDevicesCommand, message: ", error);
                    this.searchResults = [];
                    this.loading = false;
                }
            }
        },

        searchResultsFlat(tree) {
            var res = [];
            if (tree)
                tree.forEach((item) => {
                    if (item.type == DeviceTreeNodeTypeEnum.Device) res.push(item.name);
                    else res = res.concat(this.searchResultsFlat(item.children));
                });
            return res;
        },

        reset() {
            this.searchFilter.installationName = null;
            this.searchFilter.machinesSerialNumber = null;
            this.selectedFolder = null;
            this.selectedBranch = null;
            this.selectedTagKey = null;
            this.selectedTagValue = null;
            this.localSelection = [];
            this.searchResults = [];
        },

        clearLocalSelection() {
            this.localSelection = [];
        },
    },
    async mounted() {
        this.searchFilter = new SearchFilter(this.folderIdsWhereSearchIn, null, null, null, null, new TagValues());
        if (this.preselectedFolderId != null) this.selectedFolder = this.comboboxFolderItems.filter((c) => c.value == this.preselectedFolderId)[0];
        Object.assign(this.localSelection, this.value);

        this.loading = true;
        if (this.availableBranches == null || !this.availableBranches.length) await this[a.GET_AVAILABLE_BRANCHES]();
        if (this.availableTags == null || !this.availableTags.length) await this[a.GET_AVAILABLE_TAGS]();
        this.loading = false;
    },
});
